import React, { useState, useEffect } from 'react';
import API from '../../pages/Api';
import { toast } from 'react-toastify';
import { FaCalendarAlt, FaTimes } from 'react-icons/fa';
import TableContainer from '../common/Tablecontainer';

const AppointmentBooking = () => {
    const [appointments, setAppointments] = useState([]);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [bookingData, setBookingData] = useState({ BookedDate: '', BookedTime: '' });
    const [mobileData, setMobileData] = useState([]);
    const [mobilePage, setMobilePage] = useState(1);
    const [mobileTotalPages, setMobileTotalPages] = useState(1);
    const [loadingCards, setLoadingCards] = useState(false);

    useEffect(() => { ; }, []);
    const loadAppointmentCards = async (page = 1, search = "") => {
        setLoadingCards(true);

        try {
            const res = await API.get(
                `getAllAppointments?page=${page}&search=${search}`
            );

            setMobileData(res.data);
            setMobileTotalPages(1);
            setMobilePage(page);

        } finally {
            setLoadingCards(false);
        }
    };
    useEffect(() => {
        loadAppointmentCards();
    }, []);
    useEffect(() => {
        const timer = setTimeout(() => {
            loadAppointmentCards(1, searchQuery);
        }, 300);

        return () => clearTimeout(timer);

    }, [searchQuery]);

    const fetchAppointments = async () => {
        setLoading(true);
        try {
            const res = await API.get('getAllAppointments');
            setAppointments(res.data);
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handleViewClick = async (bookId, fullObject) => {
       
        console.log("Passed bookId:", bookId);
        console.log("Full Row Object:", fullObject);

        if (!bookId) {
            toast.error("Error: Appointment ID is missing! Full Object: " + JSON.stringify(fullObject));
            return;
        }

        try {
            const res = await API.get(`getAppointmentDtlsById?bookId=${bookId}`);
            setSelectedBooking(res.data);
            setIsModalOpen(true);
        } catch (err) { 
            console.error("API Error:", err); 
        }
    };

    const handleBook = async () => {
    
        console.log("Selected Booking Object:", selectedBooking);
        
       
        const bookId = selectedBooking?.appointmentid; 

        if (!bookId) {
            toast.error("Error: Appointment ID is missing! Cannot save.");
            return;
        }

        try {
           
            await API.post(`saveBookingDtls?bookId=${bookId}`, bookingData);
            toast.success("Appointment Booked Successfully!");
            setIsModalOpen(false);
        } catch (err) { 
            console.error("Save Error:", err); 
        }
    };

    const filteredData = appointments.filter(a => a.Name?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans">
            <h2 className="text-4xl font-light text-left mb-10 text-gray-800">Appointment Booking Details</h2>
            <div className="hidden md:block">
            <TableContainer
                columns={['User Name', 'Course', 'Mobile No.', 'View']}
                apiUrl="getAllAppointments"
                loading={loading}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                searchPlaceholder="Search by Name..."
                renderRow={(q, i, srNo) => (
                    <tr key={q.AppointmentId} className="border-b hover:bg-white text-sm">
                        <td className="p-3 border-r font-semibold text-gray-500">{srNo}</td>
                        <td className="p-3 border-r font-semibold text-left text-gray-500">{q.Name}</td>
                        <td className="p-3 border-r font-semibold text-left text-gray-500">{q.AmtDesc}</td>
                        <td className="p-3 border-r font-semibold text-gray-500">{q.mobileno}</td>
                        <td className="p-3 border-r">
                            <button 
                                onClick={() => {
                                    
                                    handleViewClick(q.appointmentid, q); 
                                }} 
                                className="text-blue-900 hover:text-[#64a106] transition"
                            >
                                <FaCalendarAlt size={20} />
                            </button>
                        </td>
                    </tr>
                )}
            />
            </div>
            <div className="md:hidden mb-4">

            <input
            type="text"
            value={searchQuery}
            onChange={(e)=>setSearchQuery(e.target.value)}
            placeholder="Search by Name..."
            className="
            w-full
            border
            rounded-xl
            p-3
            outline-none
            "
            />

            </div>
            <div className="md:hidden w-full px-2 mt-4 space-y-4">

                {loadingCards ? (
                    <div className="text-center py-10">
                        Loading...
                    </div>
                ) : mobileData.length === 0 ? (
                    <div className="text-center py-10 text-gray-500">
                        No Records Found
                    </div>
                ) : (

                    mobileData.map((q) => (

                        <div
                            key={q.appointmentid}
                            className="
                            bg-white
                            rounded-xl
                            shadow-sm
                            border
                            border-gray-200
                            p-4
                            w-full
                            min-w-0
                            overflow-hidden
                            "
                        >

                            <div className="space-y-3">

                                <div>
                                    <p className="text-xs text-gray-500">
                                        User Name
                                    </p>

                                    <p className="font-semibold break-words">
                                        {q.Name}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-gray-500">
                                        Course
                                    </p>

                                    <p className="break-words">
                                        {q.AmtDesc}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-gray-500">
                                        Mobile No
                                    </p>

                                    <p>
                                        {q.mobileno}
                                    </p>
                                </div>

                                <div className="pt-2">

                                    <button
                                        onClick={() =>
                                            handleViewClick(q.appointmentid, q)
                                        }
                                        className="
                                        w-full
                                        bg-[#032167]
                                        text-white
                                        py-2.5
                                        rounded-lg
                                        font-semibold
                                        "
                                    >
                                        Book Appointment
                                    </button>

                                </div>

                            </div>

                        </div>

                    ))

                )}

            </div>
            <div className="flex justify-center items-center gap-3 mt-5">

            <button
            disabled={mobilePage===1}
            onClick={()=>{
            loadAppointmentCards(
            mobilePage-1,
            searchQuery
            )
            }}
            className="
            px-4
            py-2
            rounded-lg
            bg-gray-200
            disabled:opacity-50
            "
            >
            Previous
            </button>

            <span className="font-semibold text-sm">

            {mobilePage} / {mobileTotalPages}

            </span>

            <button
            disabled={mobilePage===mobileTotalPages}
            onClick={()=>{
            loadAppointmentCards(
            mobilePage+1,
            searchQuery
            )
            }}
            className="
            px-4
            py-2
            rounded-lg
            bg-[#032167]
            text-white
            disabled:opacity-50
            "
            >

            Next

            </button>

            </div>

            {/* Creative Modal */}
            {isModalOpen && selectedBooking && (

            <div
            className="
            fixed
            inset-0
            z-[6000]
            bg-black/60
            flex
            items-center
            justify-center
            p-3
            overflow-y-auto
            "
            >

            <div
            className="
            bg-white
            w-full
            max-w-xl
            rounded-2xl
            shadow-2xl
            max-h-[90vh]
            overflow-y-auto
            "
            >

            <div
            className="
            flex
            justify-between
            items-center
            bg-[#64a106]
            text-white
            px-5
            py-4
            rounded-t-2xl
            "
            >

            <h3 className="font-bold text-sm md:text-lg uppercase">
            Appointment Booking
            </h3>

            <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="text-white"
            >
            <FaTimes size={20}/>
            </button>

            </div>

            <div className="p-4 md:p-6 space-y-5">

            <div
            className="
            grid
            grid-cols-1
            md:grid-cols-2
            gap-4
            "
            >

            <div className="md:col-span-2">
            <label className="text-xs font-semibold text-gray-500 uppercase">
            Name
            </label>

            <div className="mt-1 p-3 bg-gray-100 rounded-lg">
            {selectedBooking.Name}
            </div>

            </div>

            <div>
            <label className="text-xs font-semibold text-gray-500 uppercase">
            Age
            </label>

            <div className="mt-1 p-3 bg-gray-100 rounded-lg">
            {selectedBooking.age}
            </div>

            </div>

            <div>
            <label className="text-xs font-semibold text-gray-500 uppercase">
            Occupation
            </label>

            <div className="mt-1 p-3 bg-gray-100 rounded-lg">
            {selectedBooking.occupation}
            </div>

            </div>

            <div className="md:col-span-2">

            <label className="text-xs font-semibold text-gray-500 uppercase">
            Problem
            </label>

            <div className="mt-1 p-3 bg-gray-100 rounded-lg break-words">
            {selectedBooking.problem}
            </div>

            </div>

            </div>

            <hr/>

            <div className="space-y-4">

            <div>

            <label className="block text-xs font-semibold mb-2 uppercase">
            Booking Date
            </label>

            <input
            type="date"
            className="
            w-full
            border
            rounded-lg
            p-3
            "
            onChange={(e)=>
            setBookingData({
            ...bookingData,
            BookedDate:e.target.value
            })
            }
            />

            </div>

            <div>

            <label className="block text-xs font-semibold mb-2 uppercase">
            Booking Time
            </label>

            <input
            type="time"
            className="
            w-full
            border
            rounded-lg
            p-3
            "
            onChange={(e)=>
            setBookingData({
            ...bookingData,
            BookedTime:e.target.value
            })
            }
            />

            </div>

            </div>

            <div
            className="
            flex
            flex-col-reverse
            md:flex-row
            justify-end
            gap-3
            pt-4
            border-t
            "
            >

            <button
            type="button"
            onClick={()=>setIsModalOpen(false)}
            className="
            w-full
            md:w-auto
            px-6
            py-3
            bg-gray-100
            rounded-lg
            font-semibold
            "
            >
            Cancel
            </button>

            <button
            type="button"
            onClick={handleBook}
            className="
            w-full
            md:w-auto
            px-8
            py-3
            bg-[#64a106]
            text-white
            rounded-lg
            font-bold
            "
            >
            Confirm Booking
            </button>

            </div>

            </div>

            </div>

            </div>

            )}
        </div>
    );
};

export default AppointmentBooking;